export default __webpack_public_path__ + "static/media/games-rodape.b10adcec.png";